export default "__VITE_ASSET__UXuUe7gs__"